import script from "./GoodsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsSelector.vue?vue&type=script&setup=true&lang=js"

import "./GoodsSelector.vue?vue&type=style&index=0&id=5f85e01e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f85e01e"]])

export default __exports__